import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import axios from 'axios'
import Button from '../../components/General/Button'

const server = process.env.REACT_APP_SERVER_URL
const UserFormEdit: React.FC<IUserFormEdit> = ({ defaultValues, onSubmit }) => {
  const form = useForm({
    defaultValues,
  })

  let userTypes = [
    {
      value: 'cashier',
      text: 'Cajero',
      tooltipValue: "Tiene acceso solo al módulo de “Ventas”. No puede generar ventas a crédito."
    },
    {
      value: 'admin',
      text: 'Admin. Sistema',
      tooltipValue: "Tiene acceso a todos los módulos a excepción de Estadísticas del Negocio y Configuración."
    },
    {
      value: "general_manager",
      text: "Gerente General",
      tooltipValue: "Tiene acceso a todos los módulos a excepción de Configuración."
    },
    {
      value: "waiter",
      text: "Mesonero",
      tooltipValue: ""
    }
  ]

  let status = [
    {
      value: 'true',
      text: 'Activo',
    },
    {
      value: 'false',
      text: 'Inactivo',
    },
  ]

  const [alreadyExists, setAlreadyExists] = useState<boolean>(false)

  const getUserType = () => {
    return userTypes?.find((type) => type?.value === defaultValues?.userRole)
  }

  const getEnabled = () => {
    return status.find((v) => v?.value === defaultValues?.enabled + '')
  }

  return (
    <Form
      form={form}
      onSubmit={(values) => {
        console.log('values...', values)
        // if (values?.email?.trim() !== values?.email) {
        //   form.setError('email', {
        //     message: 'El correo no debe contener espacios al inicio o al final'
        //   })
        //   return
        // }
        onSubmit(values)
      }}
      classes="gap-x-5"
    >
      <FormItem
        name="realName"
        classes="col-span-7"
        rules={{ required: 'Es necesario el nombre' }}
      >
        <InputText small label="Nombre" disableInput />
      </FormItem>

      <FormItem
        name="userRole"
        defaultValue={getUserType()}
        classes="col-span-5"
      >
        <Select
          options={userTypes}
          setSelectedHelper={async (v) => {}}
          label="Tipo"
        />
      </FormItem>

      <FormItem
        name="email"
        classes="col-span-7"
        rules={{ 
          required: 'Es necesario el correo',
          pattern: {
            value: /^[^\s\\/]+@[^\s\\/]+\.[^\s\\/]+$/,
            message: 'El correo no debe contener espacios ni caracteres especiales'
          },
          // validate: (value) => {
          //   console.log('value probando...', value)
          //   if (value.trim() !== value) {
          //     console.log('value...', value)
          //     return 'El correo no debe contener espacios al inicio o al final'
          //   }
          //   return true
          // }
        }}
      >
        <InputText
          disableInput
          small
          label="Correo"
        />
      </FormItem>

      <FormItem name="enabled" defaultValue={getEnabled()} classes="col-span-5">
        <Select
          options={status}
          setSelectedHelper={async (v) => {}}
          label="Estado"
        />
      </FormItem>

      <div className="col-span-12 h-full flex flex-row mt-1">
        <Button type="primary" classes="rounded" htmlType="submit">
          Guardar
        </Button>
      </div>
    </Form>
  )
}

interface IUserFormEdit {
  defaultValues: any
  onSubmit: (values) => void
}

export default UserFormEdit
